import { TableGridLogicOperator } from '../types';

export const tableFilterTextOperators: Array<{ label: string; value: string }> =
  [
    { label: 'contains', value: 'contains' },
    { label: 'does not contain', value: 'doesNotContain' },
    { label: 'equals', value: 'equals' },
    { label: 'does not equal', value: 'doesNotEqual' },
    { label: 'starts with', value: 'startsWith' },
    { label: 'ends with', value: 'endsWith' },
    { label: 'is empty', value: 'isEmpty' },
    { label: 'is not empty', value: 'isNotEmpty' },
    { label: 'is any of', value: 'isAnyOf' },
  ];

export const tableFilterLogicalOperators: Array<{
  label: string;
  value: TableGridLogicOperator;
}> = [
  { label: 'AND', value: TableGridLogicOperator.And },
  { label: 'OR', value: TableGridLogicOperator.Or },
];

export const tableFilterBooleanOperators: Array<{
  label: string;
  value: string;
}> = [
  { label: 'Any', value: 'any' },
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
];

export const tableFilterDateOperators: Array<{ label: string; value: string }> =
  [
    { label: 'Is', value: 'is' },
    { label: 'Is not', value: 'isNot' },
    { label: 'Is after', value: 'isAfter' },
    { label: 'Is on or after', value: 'isOnOrAfter' },
    { label: 'Is before', value: 'isBefore' },
    { label: 'Is on or before', value: 'isOnOrBefore' },
    { label: 'Is empty', value: 'isEmpty' },
    { label: 'Is not empty', value: 'isNotEmpty' },
  ];

export const tableFilterDateTimeOperators: Array<{
  label: string;
  value: string;
}> = [
  { label: 'Is', value: 'is' },
  { label: 'Is not', value: 'isNot' },
  { label: 'Is after', value: 'isAfter' },
  { label: 'Is on or after', value: 'isOnOrAfter' },
  { label: 'Is before', value: 'isBefore' },
  { label: 'Is on or before', value: 'isOnOrBefore' },
  { label: 'Is empty', value: 'isEmpty' },
  { label: 'Is not empty', value: 'isNotEmpty' },
];

export const tableFilterNumberOperators: Array<{
  label: string;
  value: string;
}> = [
  { label: '=', value: '=' },
  { label: '!=', value: '!=' },
  { label: '>', value: '>' },
  { label: '>=', value: '>=' },
  { label: '<', value: '<' },
  { label: '<=', value: '<=' },
  { label: 'is empty', value: 'isEmpty' },
  { label: 'is not empty', value: 'isNotEmpty' },
  { label: 'is any of', value: 'isAnyOf' },
];

export const tableFilterListOperators: Array<{ label: string; value: string }> =
  [
    { label: 'is', value: 'is' },
    { label: 'is not', value: 'isNot' },
    { label: 'is any of', value: 'isAnyOf' },
  ];
